import { render, staticRenderFns } from "./ItemUpdateDialogReplacedBy.vue?vue&type=template&id=2408450d&scoped=true"
import script from "./ItemUpdateDialogReplacedBy.vue?vue&type=script&lang=ts"
export * from "./ItemUpdateDialogReplacedBy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2408450d",
  null
  
)

export default component.exports